export const DefaultPageSkeleton = () => {
  return (
    <div className="w-full p-8 xl:container lg:px-16 xl:mx-auto">
      <div className="flex items-center justify-between">
        <div className="h-8 w-44 animate-pulse rounded-md bg-skeleton" />
        <div className="h-10 w-32 animate-pulse rounded-md bg-skeleton" />
      </div>
      <div className="mt-9 h-[600px] w-full animate-pulse rounded-md bg-skeleton" />
    </div>
  )
}
